/**
 * Admin Templates API client (Phase 30).
 *
 * All endpoints are gated server-side on the `admin` Cognito group.
 * Templates are NOT git-gated — writes go directly to DDB.
 */

import { request } from "./api.js";

export const listAdminTemplates = () => request("/api/admin/templates");

export const getAdminTemplate = (templateId) =>
  request(`/api/admin/templates/${encodeURIComponent(templateId)}`);

export const createAdminTemplate = (payload) =>
  request("/api/admin/templates", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateAdminTemplate = (templateId, payload) =>
  request(`/api/admin/templates/${encodeURIComponent(templateId)}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const deleteAdminTemplate = (templateId) =>
  request(`/api/admin/templates/${encodeURIComponent(templateId)}`, {
    method: "DELETE",
  });

export const getTemplateUploadUrl = (templateId, filename) =>
  request(
    `/api/admin/templates/${encodeURIComponent(templateId)}/upload-url`,
    {
      method: "POST",
      body: JSON.stringify({ filename }),
    },
  );
